import NavigateNextIcon from '@material-ui/icons/NavigateNext';

export const CustomConnector = () => {
  return <NavigateNextIcon fontSize="small" />;
};
